import React from 'react';

import { FormField } from 'fr-shared/components';

const BuildHeightFormField = props => {
  return <FormField name="build_height" label="Build Height" append="mm" {...props} />;
};

export default BuildHeightFormField;
